import { Component, OnInit } from '@angular/core';
import { AuthService } from './core/auth.service';

@Component({
  standalone: false,
  selector: 'app-root',
  template: '<router-outlet></router-outlet>'
})
export class AppComponent implements OnInit {
  constructor(private auth: AuthService) {}

  ngOnInit(): void {
    // On app startup, check if existing auth cookie is still valid.
    // The AuthGuard handles redirects - no navigation needed here.
    this.auth.checkAuth().subscribe();
  }
}
